import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { useAuthModalStore } from '../stores/useAuthModalStore';
import { MAINTENANCE_MODE, isEmailAllowed, MAINTENANCE_MESSAGE } from '../config/maintenance';
import toast from 'react-hot-toast';

const ProtectedRoute: React.FC = () => {
    const { isAuthenticated, isLoading, checkAuth, user, logout } = useAuthStore();
    const { openModal } = useAuthModalStore();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    // Pages that don't require authentication
    const publicPaths = ['/', '/help', '/terms', '/privacy'];
    const isPublicPath = publicPaths.includes(location.pathname);

    // Check maintenance mode and logout unauthorized users
    useEffect(() => {
        if (!isLoading && isAuthenticated && user && MAINTENANCE_MODE) {
            if (!isEmailAllowed(user.email)) {
                toast.error(MAINTENANCE_MESSAGE);
                logout().then(() => {
                    navigate('/login', { replace: true });
                });
            }
        }
    }, [isLoading, isAuthenticated, user, logout, navigate]);

    useEffect(() => {
        // If not authenticated and not on a public path, open the auth modal
        if (!isLoading && !isAuthenticated && !isPublicPath) {
            openModal({ redirectPath: location.pathname });
        }
    }, [isLoading, isAuthenticated, isPublicPath, location.pathname, openModal]);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-snapfy-bg flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#7063f7]"></div>
            </div>
        );
    }

    // Always render the content - the modal will handle auth for protected pages
    // For non-public paths without auth, we still render but the modal will be open
    return <Outlet />;
};

export default ProtectedRoute;

